import Vue from "vue";

export default {
  recuperarTiposNacionalidade() {
    return Vue.axios.get("tipoNacionalidade");
  },
};
